import { TableCellType } from "../../custom-table/table";
import { DOWNLOAD_FILES_TABLE_KEYS } from "./constants";

export const downloadFilesTableHeaders = [
  {
    label: "File Name",
    key: DOWNLOAD_FILES_TABLE_KEYS.FILE_NAME,
    order: 1,
    width: 85,
    type: TableCellType.STRING,
    sortable: false,
  },
  {
    label: "",
    key: DOWNLOAD_FILES_TABLE_KEYS.DOWNLOAD,
    order: 2,
    width: 15,
    type: TableCellType.DOWNLOAD_ICON,
    sortable: false,
  },
];
